import { color } from 'highcharts';
import React from 'react';
import { useState, useEffect } from 'react';
import { Card, FormGroup, Label, Input, Row, Col, Button, Form, FormFeedback } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import Datetime from 'react-datetime';
import 'moment/locale/es';
import moment from "moment";



export const ModalSampleMicro = ({ isOpen, toggle, samples, sample, thermometers = [], containers = [], handleChangeMic, saveMicDetailSend, status, getDataSamplePost, reasons = [], units = [], characteristic = [], loadingMic }) => {
    const [isRejected, setIsRejected] = useState(false);

    const [temperatureError, setTemperatureError] = useState(false);
    const [quantityError, setQuantityError] = useState(false);
    const [rejectionReasonError, setRejectionReasonError] = useState(false);



    useEffect(() => {
        if (sample && sample.generalRanges) {
            const quantity = parseFloat(getInputValue('quantity_send'));
            const minQty = sample.generalRanges[0].quantity_range_from;
            const maxQty = sample.generalRanges[0].quantity_range_to;

            if (!isNaN(quantity) && (quantity < minQty || quantity > maxQty)) {
                setQuantityError(true);
            } else {
                setQuantityError(false);
            }
        }
    }, [sample]);



    useEffect(() => {
        if (sample && sample.generalRanges) {
            const temperature = parseFloat(getInputValue('temperature_send'));
            const min = sample.generalRanges[0].temperature_range_from;
            const max = sample.generalRanges[0].temperature_range_to;

            if (!isNaN(temperature) && (temperature < min || temperature > max)) {
                setTemperatureError(true);
            } else {
                setTemperatureError(false);
            }
        }
    }, [sample]);

    useEffect(() => {
        if (sample && sample.id_mic_status === 5) {
            setIsRejected(true);
        } else {
            setIsRejected(false);
        }
    }, [sample]);

    if (!sample) return null;

    const handleSaveMicDetailSend = async (idMicDetailSample) => {
        const rejectionReason = getInputValue('id_return_reason');
        if (isRejected && (!rejectionReason || rejectionReason === '')) {
            setRejectionReasonError(true);
            return;
        } else {
            setRejectionReasonError(false);
        }
        await saveMicDetailSend(idMicDetailSample);

    };

    const getInputValue = (field) => {
        const updatedSample = samples.find(s => s.id_mic_detail_sample === sample.id_mic_detail_sample);
        if (!updatedSample) return "";
        return updatedSample[field];
    };

    const handleTemperatureChange = (e) => {
        handleChangeMic(e, sample.id_mic_detail_sample);
    };


    const handleQuantityChange = (e) => {
        handleChangeMic(e, sample.id_mic_detail_sample);
    };


    const dialogTheme = "mic-dialog mic-blue mic-large ";


    return (
        <Dialog
            visible={isOpen}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            onHide={toggle}
            header={
                <div className="mic-dialog-header">
                    <div className="mic-dialog-header__content">

                        <div className="mic-dialog-icon">
                            <i className="icofont icofont-tablets"></i>

                        </div>

                        <div>
                            <div className="mic-dialog-title">
                                {sample.type_sample}
                            </div>

                            <div className="mic-dialog-label">
                                {sample.name_sample}
                                {sample.code && ` (${sample.code})`}
                            </div>
                        </div>

                    </div>
                </div>
            }
            className={`mic-dialog ${dialogTheme}`}
            footer={
                <Col sm="12">

                    <Button
                        size="sm"
                        color="secondary"
                        type="button"
                        onClick={() => handleSaveMicDetailSend(sample.id_mic_detail_sample)}
                        tabIndex={10}
                        disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5 || loadingMic}
                    >
                        {
                            loadingMic ? "Guardando..." : "Guardar"
                        }
                    </Button>
                </Col>
            }
        >
            <Col sm="12" className='p-l-0 p-r-0' >
                <Form style={{ padding: '15px' }} className='pr-0 pl-0' >
                    <Row>
                        <Col sm="9">
                        </Col>
                        <Col md="4" lg="3">
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "6px"
                                }}
                            >
                                <label
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#475569",
                                        marginBottom: 0
                                    }}
                                >
                                    <i
                                        className="fa fa-calendar mr-2"
                                        style={{ color: "#1d5b83" }}
                                    />
                                    Fecha de captura
                                </label>

                                <Datetime
                                    value={
                                        getInputValue("capture_date_send")
                                            ? moment(getInputValue("capture_date_send"), "YYYY-MM-DD HH:mm:ss")
                                            : null
                                    }
                                    onChange={(date) => handleChangeMic(date, sample.id_mic_detail_sample)}
                                    inputProps={{
                                        name: "capture_date_send",
                                        placeholder: "dd-mm-aaaa hh:mm:ss",
                                        className: "form-control form-control-sm",
                                        style: {
                                            height: "38px",
                                            borderRadius: "10px",
                                            border: "1px solid #dbe4ee",
                                            fontSize: "13px"
                                        },
                                        disabled: sample.id_mic_status === 4 || sample.id_mic_status === 5,

                                    }}
                                    timeFormat="HH:mm:ss"
                                    dateFormat="DD-MM-YYYY"

                                /> </div>
                        </Col>

                    </Row>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Caracteristica<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <Input
                                    type="select"
                                    name="id_characteristic_send"
                                    value={getInputValue('id_characteristic_send')}
                                    onChange={(e) => handleChangeMic(e, sample.id_mic_detail_sample)}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}
                                    tabIndex={6}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {characteristic.map((t) => (
                                        <option key={t.id_characteristic} value={t.id_characteristic}>
                                            {t.characteristic}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Cantidad</Label>
                                <Input
                                    type="number"
                                    name="quantity_send"
                                    value={getInputValue('quantity_send')}
                                    onChange={handleQuantityChange}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}
                                    tabIndex={8}
                                />

                            </FormGroup>
                        </Col>

                        <Col md={1}>
                            <FormGroup>
                                <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Unidad</Label>
                                <Input
                                    type="select"
                                    name="id_mic_cat_units"
                                    value={getInputValue('id_mic_cat_units')}
                                    onChange={(e) => {
                                        handleChangeMic(e, sample.id_mic_detail_sample);
                                        const selectedStatus = parseInt(e.target.value, 10);
                                        setIsRejected(selectedStatus === 5);
                                    }}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}
                                >
                                    <option value="">N/A</option>
                                    {units.map((s) => (
                                        <option key={s.id_mic_cat_units} value={s.id_mic_cat_units}>
                                            {s.abbreviation}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>


                        <Col md={2}>
                            <FormGroup>
                                <label style={{ color: "#1d5b83", fontSize: "12px" }}>Temperatura recepción</label>
                                <Input
                                    type="number"
                                    name="temperature_send"
                                    value={getInputValue('temperature_send')}
                                    onChange={handleTemperatureChange}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}
                                    tabIndex={1}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <label style={{ color: "#1d5b83", fontSize: "12px" }}>Termómetros</label>
                                <Input
                                    type="select"
                                    name="id_thermometer_send"
                                    value={getInputValue('id_thermometer_send')}
                                    onChange={(e) => handleChangeMic(e, sample.id_mic_detail_sample)}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}
                                    tabIndex={2}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {thermometers.map((t) => (
                                        <option key={t.id_thermometer} value={t.id_thermometer}>
                                            {t.name_thermometer}
                                        </option>
                                    ))}
                                </Input>

                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Marca y Lote</Label>
                                <Input
                                    type="text"
                                    name="mark_and_lot_send"
                                    value={getInputValue('mark_and_lot_send')}
                                    onChange={(e) => handleChangeMic(e, sample.id_mic_detail_sample)}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}

                                    tabIndex={5}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Contenedor</Label>
                                <Input
                                    type="select"
                                    name="id_container_send"
                                    value={getInputValue('id_container_send')}
                                    onChange={(e) => handleChangeMic(e, sample.id_mic_detail_sample)}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}

                                    tabIndex={6}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {containers.map((t) => (
                                        <option key={t.id_container} value={t.id_container}>
                                            {t.name_container}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>

                        <Col md={3}>
                            <FormGroup>
                                <label style={{ color: "#1d5b83", fontSize: "12px" }}>Cumple temperatura</label>
                                <Input
                                    type="text"
                                    name="comply_temperature_send"
                                    value={getInputValue('comply_temperature_send')}
                                    onChange={(e) => handleChangeMic(e, sample.id_mic_detail_sample)}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}

                                    tabIndex={4}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <label style={{ color: "#1d5b83", fontSize: "12px" }}>Temperatura corregida</label>
                                <Input
                                    type="text"
                                    name="temperature_corrected_send"
                                    value={getInputValue('temperature_corrected_send')}
                                    onChange={(e) => handleChangeMic(e, sample.id_mic_detail_sample)}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={true}
                                    tabIndex={3}
                                />
                            </FormGroup>
                        </Col>




                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Estatus<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <Input
                                    type="select"
                                    name="id_mic_status"
                                    value={getInputValue('id_mic_status')}
                                    onChange={(e) => {
                                        handleChangeMic(e, sample.id_mic_detail_sample);
                                        const selectedStatus = parseInt(e.target.value, 10);
                                        setIsRejected(selectedStatus === 5);
                                    }}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {status.map((s) => (
                                        <option key={s.id_mic_status} value={s.id_mic_status}>
                                            {s.status}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>

                        <Col md={6}>
                            <FormGroup>
                                <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Observaciones</Label>
                                <textarea
                                    className="form-control form-control-sm input-air-primary"
                                    name="comments"
                                    rows="2"
                                    value={getInputValue('comments') || ''}
                                    onChange={(e) => handleChangeMic(e, sample.id_mic_detail_sample)}
                                    disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}

                                    tabIndex={9}
                                />
                            </FormGroup>
                        </Col>






                    </Row>










                    <Row>



                    </Row>
                    {isRejected && (
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label style={{ color: "#1d5b83", fontSize: "12px" }}>Motivos de rechazo</Label>
                                    <Input
                                        type="select"
                                        name="id_return_reason"
                                        value={getInputValue('id_return_reason')}
                                        onChange={(e) => {
                                            handleChangeMic(e, sample.id_mic_detail_sample);
                                            setRejectionReasonError(false);
                                        }}
                                        className="form-control form-control-sm input-air-primary"
                                        invalid={rejectionReasonError}
                                        disabled={sample.id_mic_status === 4 || sample.id_mic_status === 5}
                                    >
                                        {rejectionReasonError && (
                                            <FormFeedback>Debe seleccionar un motivo de rechazo.</FormFeedback>
                                        )}

                                        <option value="">Selecciona una opción</option>
                                        {reasons.map((s) => (
                                            <option key={s.id_mic_return_reason} value={s.id_mic_return_reason}>
                                                {s.return_reason}
                                            </option>
                                        ))}
                                    </Input>
                                    <FormFeedback>Debe seleccionar un motivo de rechazo.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                    )}


                </Form>
            </Col>
        </Dialog>
    );
};
